import * as z from "zod";
import { aeoDashboardFilterInput } from "./types";

const visibilityTimeSeriesPoint_ = z.object({
  date: z.string(),
  score: z.number().nullable(),
  mentionCount: z.number().int().nullable(),
});

const leaderboardEntry_ = z.object({
  rank: z.number().int(),
  name: z.string(),
  website: z.string(),
  isYou: z.boolean(),
  score: z.number(),
  trend: z.number().nullable(),
});

export const getAeoDashboardVisibility = {
  name: "getAeoDashboardVisibility" as const,
  input: aeoDashboardFilterInput,
  output: z.object({
    timeSeries: z.array(visibilityTimeSeriesPoint_),
    leaderboard: z.array(leaderboardEntry_),
  }),
};
